module.exports = __webpack_public_path__ + "static/media/icon-excel.00dba3ae.svg";